export default {
    fetch: undefined
};
//# sourceMappingURL=config.js.map